import { css } from 'styled-components';

import { tokens } from 'containers/Intelligence/theme';

/**
 * PLA-8828: the pill treatment shared by `StatusBadgeWithReason` and `EventTimeline`. Declared once
 * for the reason `visuallyHidden` is — the Customer 360 frame draws the same pill in both places
 * (`3583-10309` on the identity header, the `Status` column of `3583-10820`), and two copies of a
 * geometry would drift.
 */
export type StatusPillTone = 'positive' | 'warning' | 'negative' | 'info' | 'neutral';

export const STATUS_PILL_HUES: Record<StatusPillTone, string> = {
  positive: tokens.color.positive,
  warning: tokens.color.warning,
  negative: tokens.color.negative,
  info: tokens.color['accent-blue'],
  neutral: tokens.color['text-muted']
};

/**
 * Height 20.8, radius 20 and a fill that is the pill's own ink at 14% opacity, read off `3583-10309`
 * (`color/Turquoise/山草甸绿 29 14%`). The fill is a tinted layer rather than an `rgba()` literal
 * because the ink reaches this rule as a CSS custom property, which no JS colour maths can resolve;
 * the layer sits behind a positioned label rather than at `z-index: -1`, which would drop it behind
 * the card as well as behind the pill.
 */
export const statusPill = css<{ $hue: string }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 0 ${tokens.space['12']};
  border-radius: ${tokens.radius.pill};
  color: ${({ $hue }) => $hue};
  font-size: ${tokens.type['label-size']};
  font-weight: ${tokens.type['label-weight']};
  line-height: 20.8px;
  white-space: nowrap;

  &::before {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: inherit;
    background: currentColor;
    content: '';
    opacity: 0.14;
  }
`;

export const statusPillLabel = css`
  position: relative;
`;
